
    import has from 'lodash/has';
    import { mapState, mapActions, mapMutations } from 'vuex';
    import { ValidationProvider } from 'vee-validate';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faCheckSquare as fasCheckSquare,
    } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
    import {
        faSquare as farSquare,
    } from '@fortawesome/pro-regular-svg-icons/faSquare';

    import {
        faCheckSquare as farCheckSquare,
    } from '@fortawesome/pro-regular-svg-icons/faCheckSquare';

    import {
        faCloudUpload as falCloudUpload,
    } from '@fortawesome/pro-regular-svg-icons/faCloudUpload';

    import {
        faTrashAlt as falTrashAlt,
    } from '@fortawesome/pro-regular-svg-icons/faTrashAlt';

    import {
        faInfoCircle as farInfoCircle,
    } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';

    import VueSelect from '@/components/VueSelect/VueSelect';
    import VueSelectDivider from '@/components/VueSelect/VueSelectDivider';
    import Filters from '@/components/Utils/Filters';
    import WhatIsThis from '@/components/Utils/WhatIsThis';
    import datalayer from '@/utils/datalayer';
    import C1HelpText from '@/C1Components/C1HelpText';
    import C1Label from '@/C1Components/C1Label';
    import C1Spinner from '@/C1Components/C1Spinner';

    export default {
        name: 'ApplyResume',

        components: {
            FontAwesomeIcon,
            ValidationProvider,
            VueSelect,
            VueSelectDivider,
            WhatIsThis,
            C1HelpText,
            C1Label,
            C1Spinner,
        },

        mixins: [Filters],

        data() {
            return {
                selectedResume: {},
                resumes: [],
                applyWithoutResumeText: 'Apply without a resume',
                applyNoResume: false,
                showResumeReview: false,
                response: {
                    status: '',
                    message: '',
                },
                loader: {
                    get_resumes: false,
                    store_resume: false,
                },
                isFaceBookApp: false,
                isAndroiddOS: false,
                dropzone: null,
                icons: {
                    farSquare,
                    farCheckSquare,
                    fasCheckSquare,
                    falCloudUpload,
                    falTrashAlt,
                    farInfoCircle,
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
                $_job: state => state.job.job,
                $_jobApplication: state => state.jobApplication,
            }),

            defaultText() {
                if (has(this.selectedResume, 'file_name') || has(this.selectedResume, 'filename')) {
                    return this.selectedResume.file_name || this.selectedResume.filename;
                }

                if (this.applyNoResume) {
                    return this.applyWithoutResumeText;
                }

                return 'Select resume option';
            },

            resumeFile() {
                if (process.server) {
                    return '';
                }

                return this.selectedResume instanceof File ? this.selectedResume.upload : '';
            },

            isResumeFieldValid() {
                if (this.selectedResume.id || this.resumeFile.uuid) {
                    return true;
                }

                if (this.defaultText === this.applyWithoutResumeText) {
                    return true;
                }

                return '';
            },

            resumeReview: {
                get() {
                    return this.$_jobApplication.is_resume_review;
                },

                set(value) {
                    value ? this.$_CHECK_RESUME_REVIEW() : this.$_UNCHECK_RESUME_REVIEW();
                },
            },

            makeResumeDefault: {
                get() {
                    return this.$_jobApplication.make_resume_default;
                },

                set(value) {
                    value ? this.$_CHECK_RESUME_DEFAULT() : this.$_UNCHECK_RESUME_DEFAULT();
                },
            },
        },

        watch: {
            selectedResume: {
                handler(resume) {
                    this.$emit('resumeSelected', resume);
                    this.showResumeReview = !resume.has_recent_resume_review;
                    this.showResumeReview ? this.$_CHECK_RESUME_REVIEW() : this.$_UNCHECK_RESUME_REVIEW();
                },
                deep: true,
            },
        },

        created() {
            if (this.$_me.id) {
                this.getResumes();
            }
        },

        mounted() {
            const dropzoneScript = document.createElement('script');
            dropzoneScript.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/dropzone/5.9.3/min/dropzone.min.js');
            document.head.appendChild(dropzoneScript);
            dropzoneScript.onload = () => {
                this.$nextTick(() => {
                    this.initDropzone();
                });
            };

            this.isFaceBookApp = this.$isFacebookApp();
            this.isAndroiddOS = this.$isAndroidOS();
        },

        methods: {
            ...mapActions('me', {
                $_storeResume: 'storeResume',
                $_getResume: 'getResume',
            }),

            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),

            ...mapMutations('jobApplication', {
                $_CHECK_RESUME_REVIEW: 'CHECK_RESUME_REVIEW',
                $_UNCHECK_RESUME_REVIEW: 'UNCHECK_RESUME_REVIEW',
                $_CHECK_RESUME_DEFAULT: 'CHECK_RESUME_DEFAULT',
                $_UNCHECK_RESUME_DEFAULT: 'UNCHECK_RESUME_DEFAULT',
            }),

            initDropzone() {
                // const { Dropzone } = require('dropzone');
                window.Dropzone.autoDiscover = false;
                const vm = this;
                const el = this.$el.querySelector('#dzResume');
                this.dropzone = new window.Dropzone(el, {
                    url: '/',
                    clickable: '#dzResume span',
                    maxFiles: 1,
                    addRemoveLinks: false,
                    uploadMultiple: false,
                    maxFilesize: 2,
                    autoProcessQueue: false,
                    acceptedFiles: '.pdf,.doc,.docx,.rtf,.txt',
                    createImageThumbnails: false,
                    error(file, msg) {
                        vm.response.status = 'red';
                        vm.response.message = msg;
                        vm.removeResumeFile(file);
                    },
                    accept(file) {
                        vm.response.status = '';
                        vm.response.message = '';

                        if (vm.$_me.id) {
                            vm.storeResume(file);
                        } else {
                            vm.selectResume(file);
                        }

                        this.removeFile(file);
                    },
                    addedfile() {
                    },
                });
            },

            getResumes() {
                this.loader.get_resumes = true;
                this.$_getResume().then((response) => {
                    this.resumes = response.data;
                }).finally(() => {
                    this.loader.get_resumes = false;
                });
            },

            storeResume(file) {
                this.loader.store_resume = true;
                const queueResumeParse = true;

                this.$_storeResume({ file, queueResumeParse }).then((response) => {
                    this.resumes.push(response.data);
                    this.selectResume(response.data);

                    const data = {
                        event: 'seeker_resume_upload',
                        site_position: 'application_form',
                        resume_review: false,
                        seeker_id: this.$_me.id,
                        seeker_hash: this.$_me.email_hash,
                    };
                    this.$_pushEvent(data);
                    datalayer(data);
                }).finally(() => {
                    this.loader.store_resume = false;
                });
            },

            selectResume(resume) {
                this.selectedResume = resume;
                this.$refs.resumeSelect.closeMenu();
            },

            applyWithoutResume() {
                this.removeResumeFile();
                this.applyNoResume = true;
                this.$refs.resumeSelect.closeMenu();
            },

            removeResumeFile() {
                this.selectedResume = {};
            },

            onResumeDefaultClick() {
                this.makeResumeDefault = !this.makeResumeDefault;
            },
        },
    };
